export const ArrowForwardSvg = () => {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="ArrowForwardFilled">
        <path
          id="Vector"
          d="M10.5715 3.81194C10.2493 3.51271 9.75074 3.51271 9.42848 3.81195C9.07084 4.14404 9.07059 4.70998 9.42793 5.0424L13.6488 8.96875H2.8125C2.36377 8.96875 2 9.33252 2 9.78125C2 10.23 2.36377 10.5938 2.8125 10.5938H13.6488L9.42793 14.5201C9.07059 14.8525 9.07084 15.4185 9.42848 15.7506C9.75074 16.0498 10.2493 16.0498 10.5715 15.7506L16.5626 10.1874C16.7987 9.96813 16.7987 9.59437 16.5626 9.37508L10.5715 3.81194Z"
          fill="#14A800"
        />
      </g>
    </svg>
  );
};
